import React, { useState } from "react";
import { useData } from "../../../context/DataContext";
import ImageUploadField from "../../../utils/ImageUploadField";
import { confirmDelete, successToast, errorToast } from "../../../utils/dialog";

const HospitalityAdmin = () => {
  const { hospitalityTeamData, updateHospitalityTeam, deleteHospitalityTeam } = useData();

  const [formData, setFormData] = useState({
    heading: hospitalityTeamData.heading || "",
    description: hospitalityTeamData.description || "",
    image: hospitalityTeamData.image || "",
  });
  const [imageFile, setImageFile] = useState(null); // Store the selected image file

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      const previewUrl = URL.createObjectURL(file);
      setFormData((prev) => ({ ...prev, image: previewUrl })); // Show preview
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await updateHospitalityTeam(formData, imageFile);
      successToast("Hospitality Team section updated.");
    } catch (err) {
      console.error(err);
      errorToast("Error updating Hospitality Team section.");
    }
  };

  const handleDelete = async () => {
    if (
      await confirmDelete({
        title: "Delete section?",
        text: "This Hospitality Team section will be permanently removed.",
      })
    ) {
      await deleteHospitalityTeam();
      successToast("Hospitality Team section deleted.");
    }
  };

  return (
    <div className="p-6 space-y-8">
      <h2 className="text-3xl font-bold mb-4 text-gray-800">Hospitality Team Admin Panel</h2>

      {/* Form */}
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow space-y-4">
        <h3 className="text-2xl font-semibold text-gray-700 mb-4">Update Section</h3>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Heading
          </label>
          <input
            type="text"
            name="heading"
            value={formData.heading}
            onChange={handleInputChange}
            className="w-full p-2 border rounded focus:ring-2 focus:ring-[#D48C1E]"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Description
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            rows={3}
            className="w-full p-2 border rounded focus:ring-2 focus:ring-[#D48C1E]"
          />
        </div>
        <ImageUploadField
          label="Image"
          hint="Recommended size: 800×600px"
          previewUrl={formData.image}
          file={imageFile}
          onChange={handleFileChange}
          onClear={() => {
            setImageFile(null);
            setFormData((prev) => ({ ...prev, image: "" }));
          }}
        />
        <div className="flex justify-end space-x-4">
          <button
            type="submit"
            className="px-6 py-2 bg-[#14251F] hover:bg-[#1f3a30] text-[#FFD1A0] rounded transition font-medium"
          >
            Update Section
          </button>
          <button
            type="button"
            onClick={handleDelete}
            className="px-6 py-2 bg-red-500 hover:bg-red-600 text-white rounded transition"
          >
            Delete Section
          </button>
        </div>
      </form>
    </div>
  );
};

export default HospitalityAdmin;